
export const SET_INFO_BAR                = 'SET_INFO_BAR';
export const SET_WARNING_BAR             = 'SET_WARNING_BAR';
export const SET_ERROR_BAR               = 'SET_ERROR_BAR';
export const CLEAR_MESSAGE_BAR           = 'CLEAR_MESSAGE_BAR';

export const setInfoMessageBar = (message, msgType) => ({
    type: SET_INFO_BAR,
    message,
    msgType
});

export const setWarningMessage = (warning, msgType) => ({
    type: SET_WARNING_BAR,
    warning,
    msgType
});

export const setErrorBarMessage = error => ({
    type: SET_ERROR_BAR,
    error
});

export const clearBarMessage = () => ({
    type: CLEAR_MESSAGE_BAR
});



// WEBPACK FOOTER //
// ./src/Actions/messages.js